import { apiClient } from '../config/api';

// FEAT-069 — curated careseeker leads (web client).

export interface CareseekerLead {
  id: string;
  userId: string;
  firstName: string | null;
  lastName: string | null;
  avatar: string | null;
  zipCode: string | null;
  careNeeds: string[];
  matchReason: string;
}

interface CareseekerLeadsResponse {
  success: boolean;
  data: CareseekerLead[];
}

class CareseekerLeadsService {
  async listLeads(): Promise<CareseekerLead[]> {
    const response = await apiClient.get<CareseekerLeadsResponse>(
      '/caregivers/me/careseeker-leads',
    );
    if (!response.data.success) {
      throw new Error('Failed to load careseeker leads');
    }
    return response.data.data;
  }
}

export const careseekerLeadsService = new CareseekerLeadsService();
